import { render, staticRenderFns } from "./PromosPermanentNewForm.vue?vue&type=template&id=193360cf"
import script from "./PromosPermanentNewForm.vue?vue&type=script&lang=js"
export * from "./PromosPermanentNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports